import { BrowserRouter } from "react-router-dom";
import AuthProvider from "./Auth/AuthProvider";
import AdminAuthProvider from "./Auth/AdminAuthProvider";
import AppRoutes from "./AppRoutes"; 
import { inject } from '@vercel/analytics';
import { injectSpeedInsights } from '@vercel/speed-insights';
function App() {  
  injectSpeedInsights();
  inject();
  return (
    <div className="dark:bg-gray-800">
      <BrowserRouter>
        <AuthProvider>
          <AdminAuthProvider>
            <AppRoutes />
          </AdminAuthProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
